<script>
  export let id

  import { link } from 'svelte-navigator'
  import { fetchO } from '../../oauth.js'

  import WorkoutPlanSetWidget from '../../components/WorkoutPlanSetWidget.svelte'

  // Fetch workoutplan
  let workout_plan

  async function fetchWorkoutPlan() {
    const response = await fetchO('/workout_plans/' + id + '/details/')
    workout_plan = await response.json()
  }
  fetchWorkoutPlan()
</script>

{#if !workout_plan}
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
{:else}
  <div class="d-flex pb-1">
    <div class="me-auto">
      <h3>Plan "{workout_plan.title}"</h3>
    </div>
    <div class="btn-group" role="group">
      <a
        href="/workoutplans/clone/{workout_plan.id}"
        use:link
        class="btn btn-secondary"
        ><i class="bi bi-plus-square" />
        <span class="d-none d-md-inline">Clone</span></a
      >
    </div>
  </div>

  <div class="row g-3">
    {#each workout_plan.sets as set, seti (set.id)}
      <div class="col-lg-6">
        <WorkoutPlanSetWidget {set} {seti} />
      </div>
    {/each}
  </div>
{/if}

<svelte:head>
  {#if workout_plan}
    <title>Workout Plan {workout_plan.title}</title>
  {/if}
</svelte:head>
